import api from '@/api/api';
export const projectsApi = {
    async index(filters) {
        const path = '/build_sprint/internal/api/v1/build_sprint_projects';
        const response = await api({
            method: 'get',
            url: path,
            params: filters,
        });
        return response.buildSprintProjects;
    },
    async show(id) {
        const path = `/build_sprint/internal/api/v1/build_sprint_projects/${id}`;
        const response = await api({
            method: 'get',
            url: path,
        });
        return response.buildSprintProject;
    },
};
